import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/loader";
import Alert from "components/alert";
import { setLessonId } from "services/schedule/kindergartenScheduleSlice";
import { fetchScheduleLessons } from "services/schedule/kindergartenScheduleSlice";

const SelectLesson = () => {
  const dispatch = useDispatch();

  const kindergartenSchedule = useSelector((state) => {
    return state.kindergartenSchedule;
  });

  useEffect(() => {
    dispatch(fetchScheduleLessons());
  }, [dispatch]);

  return (
    <div>
      {kindergartenSchedule.loading && <Loader />}
      {!kindergartenSchedule.loading && kindergartenSchedule.error ? (
        <Alert text={kindergartenSchedule.error} />
      ) : null}
      {!kindergartenSchedule.loading &&
      kindergartenSchedule.scheduleLessons.length ? (
        <ul className="space-y-4">
          {kindergartenSchedule.scheduleLessons.map((lesson) => (
            <li
              key={lesson.id}
              className="cursor-pointer bg-gray-100 rounded hover:bg-gray-50"
            >
              <div
                className="flex cursor-pointer p-2 items-center   "
                onClick={() => dispatch(setLessonId(lesson.id))}
              >
                <div className="p-0.5 rounded-full border-2 border-terapist-active">
                  {kindergartenSchedule.data.lessonId === lesson.id ? (
                    <div className="w-2.5 h-2.5 rounded-full bg-terapist-active"></div>
                  ) : (
                    <div className="w-2.5 h-2.5"></div>
                  )}
                </div>
                <div className="ms-2 text-sm">
                  <label
                    htmlFor={`helper-radio-${lesson.id}`}
                    className="font-medium text-gray-900 dark:text-gray-300 cursor-pointer"
                  >
                    {lesson.name} {/* Display room name */}
                  </label>
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default SelectLesson;
